import { useEvent } from "react-use";

export const useSyncDoneEvent = (callback: () => void) => {
	useEvent("syncdone", callback, window, { capture: false, passive: true });
};
